/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label[_ngcontent-%COMP%]{display:block;font-weight:700}span[_ngcontent-%COMP%]{margin:23px;display:block}"];
export { styles as styles };
